export default "https://cdn-static.gokick.com/assets/bae15fb1898ed89c0d72225e63ca082ea63e0d65/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";